import{defineMessages}from'react-intl';

export default defineMessages({
add:{
id:'i18n.adminSettingsInput.add',
defaultMessage:'ADD'},

cancel:{
id:'i18n.adminSettingsInput.cancel',
defaultMessage:'CANCEL'},

addNewItem:{
id:'i18n.adminSettingsInput.addNewItem',
defaultMessage:'Add New Item'}});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jb21wb25lbnRzL0FkbWluU2V0dGluZ3NJbnB1dC9BZG1pblNldHRpbmdzSW5wdXQubWVzc2FnZXMuanMiXSwibmFtZXMiOlsiZGVmaW5lTWVzc2FnZXMiLCJhZGQiLCJpZCIsImRlZmF1bHRNZXNzYWdlIiwiY2FuY2VsIiwiYWRkTmV3SXRlbSJdLCJtYXBwaW5ncyI6IkFBQUEsT0FBU0EsY0FBVCxLQUErQixZQUEvQjs7QUFFQSxjQUFlQSxnQkFBZTtBQUM1QkMsSUFBSztBQUNIQyxHQUFJLDZCQUREO0FBRUhDLGVBQWdCLEtBRmIsQ0FEdUI7O0FBSzVCQyxPQUFRO0FBQ05GLEdBQUksZ0NBREU7QUFFTkMsZUFBZ0IsUUFGVixDQUxvQjs7QUFTNUJFLFdBQVk7QUFDVkgsR0FBSSxvQ0FETTtBQUVWQyxlQUFnQixjQUZOLENBVGdCLENBQWYsQ0FBZiIsImZpbGUiOiJBZG1pblNldHRpbmdzSW5wdXQubWVzc2FnZXMuanMiLCJzb3VyY2VSb290IjoiL2FwcCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGRlZmluZU1lc3NhZ2VzIH0gZnJvbSAncmVhY3QtaW50bCc7XG5cbmV4cG9ydCBkZWZhdWx0IGRlZmluZU1lc3NhZ2VzKHtcbiAgYWRkOiB7XG4gICAgaWQ6ICdpMThuLmFkbWluU2V0dGluZ3NJbnB1dC5hZGQnLFxuICAgIGRlZmF1bHRNZXNzYWdlOiAnQUREJyxcbiAgfSxcbiAgY2FuY2VsOiB7XG4gICAgaWQ6ICdpMThuLmFkbWluU2V0dGluZ3NJbnB1dC5jYW5jZWwnLFxuICAgIGRlZmF1bHRNZXNzYWdlOiAnQ0FOQ0VMJyxcbiAgfSxcbiAgYWRkTmV3SXRlbToge1xuICAgIGlkOiAnaTE4bi5hZG1pblNldHRpbmdzSW5wdXQuYWRkTmV3SXRlbScsXG4gICAgZGVmYXVsdE1lc3NhZ2U6ICdBZGQgTmV3IEl0ZW0nLFxuICB9LFxufSk7XG5cbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ./src/components/AdminSettingsInput/AdminSettingsInput.messages.js
// module id = 2346
// module chunks = 0